{
  "language": {
    "name": "Español",
    "choose": "Idioma",
    "reviewed": "no",
    "unreviewedNotice": "Esta interfaz en español es una traducción provisional sin revisar. El contenido de la historia clínica se muestra siempre tal como se escribió."
  },
  "app": {
    "name": "Continuum",
    "banner": "HISTORIA CLÍNICA DE CONTINGENCIA"
  },
  "nav": {
    "ward": "Lista de la unidad",
    "search": "Buscar paciente",
    "register": "Nuevo paciente"
  },
  "status": {
    "checking": "Comprobando …",
    "ready": "Base de datos conectada",
    "aliveNoDatabase": "La API responde, base de datos no disponible",
    "unreachable": "La API no responde"
  },
  "action": {
    "openPatient": "Abrir el resumen del paciente {name}"
  },
  "value": {
    "notRecorded": "No consta",
    "unreadable": "No se puede mostrar"
  },
  "identity": {
    "nameMissing": "Falta el nombre",
    "age": "{years} años"
  },
  "safety": {
    "allergyActive": "Alergia",
    "allergyUnknown": "Alergia no evaluada",
    "allergyNoneKnown": "Sin alergias conocidas",
    "allergyUndocumented": "Alergia no documentada",
    "dnr": "DNR",
    "isolation": "Aislamiento: {type}",
    "estimatedIdentity": "No identificado",
    "confidentialityMarked": "Identidad protegida",
    "deceased": "Fallecido"
  },
  "deployment": {
    "internetDemo": "Entorno de pruebas en internet. No introduzca nunca datos reales de pacientes: todo aquí es ficticio y lo que escriba pueden leerlo otras personas que hacen pruebas."
  }
}
